<template>
    <el-dialog title="购买后关注二维码" :visible.sync="centerDialogVisible" width="600px" class="buyCode">
        <ShopLocalCropper :cropperOption="cropperOption" ref="localCropper" @setImage="_setImage" :uploadType="uploadType"></ShopLocalCropper>
        <div class="openCloseBigBox">
            <p class="title">购买后引导关注</p>
            <div class="openCloseBox">
                <el-radio-group v-model="buyData.isOpen">
                    <el-radio :label="1">开启</el-radio>
                    <el-radio :label="0">关闭</el-radio>
                </el-radio-group>
                <p>开启后，用户购买内容后会引导关注相关内容；</p>
                <p>关闭后，用户购买内容直接进入内容</p>
            </div>

        </div>
        <div class="codeName">
            <p class="title">引导描述</p>
            <el-input v-model.trim="buyData.desc" :disabled="buyData.isOpen === 0" placeholder="请输入引导描述" maxlength="30" show-word-limit></el-input>
        </div>
        <div class="codeName">
            <p class="title">二维码名称</p>
            <el-input v-model.trim="buyData.codeName" :disabled="buyData.isOpen === 0" placeholder="请输入二维码名称" maxlength="10" show-word-limit></el-input>
        </div>
        <div class="buyCodeBox">
            <p class="title">公众号二维码</p>
            <div class="upload cover-image" @click="openDialog">
                <div class="avatar-uploader">
                    <div class="el-upload el-upload--text">
                        <img class="uploadImgIcon" :src="require('@/common/images/other/upload.png')" v-if="!img" alt="">
                        <img :src="img.furl +'?'+timestamp" alt="" class="uploadImg" v-else-if="img.furl && img.furl + '?' + timestamp">
                        <img :src="img" alt="" class="uploadImg" v-else>
                    </div>
                </div>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirm">确 定</el-button>
        </span>
    </el-dialog>
</template>
<script>
import ShopLocalCropper from 'base/cropper/shopLocalCropper'
import {mapGetters, mapActions} from 'vuex'
import {updateShopSet} from 'api/accountApi'
export default {
    name: 'buyCode',
    data() {
        return {
            centerDialogVisible: false,
            img: '',
            buyData: {
                codeName: '',
                isOpen: 1,
                desc: ''
            },
            timestamp: new Date().getTime(),
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [110, 110], // 截图框的宽高比例
                enlarge: 2.5, // 图片根据截图框输出比例倍数
                autoCropWidth: 110, // 默认生成截图框宽度
                autoCropHeight: 110 // 默认生成截图框高度
            }
        }
    },
    props: ['data'],
    methods: {
        openDialog() {
            if (this.buyData.isOpen === 1) {
                this.$refs.localCropper.openDialog()
            } else {
                this.$message.error('需要开启后才可上传')
            }
        },
        _setImage(file) {
            this.timestamp = new Date().getTime()
            this.img = file
        },
        close() {
            this.centerDialogVisible = false
            this.img = ''
            this.data.codeName = ''
            this.data.desc = ''
        },
        confirm() {
            if (this.buyData.isOpen === 1) {
                if (this.img) {
                    if (this.img.furl) {
                        delete this.img.type
                        this.img = JSON.stringify(this.img)
                    } else {
                        this.img = ''
                    }
                    this.setLoading(true)
                    updateShopSet({
                        data: {orderqrcodeinfo:this.img, issubscribeorder: this.buyData.isOpen, orderdesp: this.buyData.desc, orderqrcodename: this.buyData.codeName},
                        success: data => {
                            this.setLoading(false)
                            this.centerDialogVisible = false
                            this.$message.success('设置成功')
                            this.$emit('getMsg')
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
                } else {
                    this.$message.error('请上传二维码')
                }
            } else {
                this.setLoading(true)
                    updateShopSet({
                        data: {orderqrcodeinfo: '', issubscribeorder: this.buyData.isOpen, orderdesp: '', orderqrcodename: ''},
                        success: data => {
                            this.setLoading(false)
                            this.centerDialogVisible = false
                            this.$message.success('设置成功')
                            this.$emit('getMsg')
                        },
                        error: data => {
                            this.setLoading(false)
                            this.$message.error(data.msg)
                        }
                    })
            }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    components: {
        ShopLocalCropper
    },
    watch: {
        'data': {
            handler(newV) {
                if (newV) {
                    this.buyData.isOpen = newV.issubscribeorder
                    this.buyData.codeName = newV.orderqrcodename
                    this.buyData.desc = newV.orderdesp
                    this.img = newV.orderqrcodeurl
                }
            }
        },
        deep: true
    }
}
</script>
<style lang="scss">
    .buyCode{
        .title{
            width: 98px;
        }
        .openCloseBigBox{
            display: flex;
            margin-bottom: 15px;
            .openCloseBox{
                margin-left: 40px;
                p{
                    color: #909399;
                    line-height: 20px;
                }
            }
        }
        .codeName{
            display: flex;
            margin-bottom: 15px;
            align-items: center;
            .el-input{
                margin-left: 40px;
                width: 400px;
            }
        }
        .buyCodeBox{
            display: flex;
            justify-content: flex-start;
            .upload{
                margin-left: 40px;
                .avatar-uploader{
                    display: flex;
                    .el-upload{
                        width: 110px;
                        height: 110px;
                        margin-right: 10px;
                        background: #F5F7FA;
                        line-height: 110px;
                        text-align: center;
                        .uploadImgIcon{
                            width: 21px;
                            height: 21px;
                        }
                        .uploadImg{
                            width: 110px;
                            height: 110px;
                        }
                    }
                    .el-upload__tip{
                        color: #C0C4CC;
                        font-size: 14px;
                    }
                }
            }
        }
    }
</style>
